import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import { routerReducer, routerMiddleware } from './core/router/react-router-redux-compat';
import { courses } from './courses/courses.reducer';
import { manuals } from './manuals/manuals.reducer';
import { videos } from './videos/videos.reducer';
import { feed } from './feed/feed.reducer';
import { students } from './students/students.reducer';

const isDev = import.meta.env.DEV;

const enhancers = compose(
  applyMiddleware(routerMiddleware(), thunk),
);

export const store = createStore(
  combineReducers({
    router: routerReducer,
    courses,
    feed,
    students,
    manuals,
    videos,
  }),
  enhancers,
);

if (isDev) {
  // redux-logger removed from production per plan
}
